var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M8.049 0A6.946 6.946 0 001.06 6.989a6.713 6.713 0 002.1 4.992c.1.1 4.094 3.7 4.194 3.794a1.046 1.046 0 001.3 0c.1-.1 4.193-3.694 4.193-3.794a6.711 6.711 0 002.1-4.992A6.8 6.8 0 008.049 0zm0 8.986a2 2 0 112-2 2 2 0 01-2 2z","fill":"#53647f","data-name":"Layer 1"})));
}

Location.defaultProps = {"width":"16","height":"16"};

module.exports = Location;

Location.default = Location;
